import { memo, type ReactNode } from 'react'

import type { DataTableFilter } from './data-table.interface'
import { DataTableSearch } from './data-table-search.atom'
import { DataTableToolbarFilters } from './data-table-toolbar-filters.atom'

interface DataTableToolbarSearchFiltersProps {
  searchValue?: string
  onSearchChange?: (value: string) => void
  searchPlaceholder?: string
  filterList?: DataTableFilter[]
  showFilters: boolean
  hasActiveFilters: boolean
  getFilterValues: (filterId: string) => string[]
  onFilterChange: (filterId: string, valueList: string[]) => void
  onClearFilters: () => void
}

/**
 * Renders the search input and filter dropdowns for the toolbar.
 */
const DataTableToolbarSearchFiltersBase: React.FC<DataTableToolbarSearchFiltersProps> = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filterList,
  showFilters,
  hasActiveFilters,
  getFilterValues,
  onFilterChange,
  onClearFilters,
}): ReactNode => (
  <>
    {onSearchChange && (
      <DataTableSearch
        value={searchValue ?? ''}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
      />
    )}
    {showFilters && filterList && (
      <DataTableToolbarFilters
        filterList={filterList}
        hasActiveFilters={hasActiveFilters}
        getFilterValues={getFilterValues}
        onFilterChange={onFilterChange}
        onClearFilters={onClearFilters}
      />
    )}
  </>
)

export const DataTableToolbarSearchFilters = memo(DataTableToolbarSearchFiltersBase)

DataTableToolbarSearchFilters.displayName = 'DataTableToolbarSearchFilters'
